import * as API from '@siloreal:shared:api';

const LOT_LIST_ENDPOINT = '/lots';

export type LotListQueryValue = string | number | boolean | undefined | null;

export type LotListQuery = Partial<{
  id: LotListQueryValue;
  full_permission: LotListQueryValue;
}>;

export type LotListServiceContract = {
  query?: LotListQuery;
  signal?: AbortSignal;
};

export async function listLotsService(contract: LotListServiceContract = {}): Promise<LotListResponse> {
  const { data } = await API.http.fetch.get<LotListApiResponse>(LOT_LIST_ENDPOINT, {
    query: buildLotListQuery(contract.query),
    signal: contract.signal,
  });

  return toLotListResponse(data);
}

export function buildLotListQuery(query?: LotListQuery): string {
  const queryParameters = new URLSearchParams();

  Object.entries(query ?? {}).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (typeof value === 'string' && value.trim().length === 0) return;

    queryParameters.set(key, String(value).trim());
  });

  const serializedQuery = queryParameters.toString();

  return serializedQuery ? `?${serializedQuery}` : '';
}

export type LotListResponse = LotListItem[];

type LotListApiResponse = LotListResponse | string;

export type LotListItem = {
  id: number;
  name: string;
  active: boolean;
  created_at: Date | string;
  updated_at: Date | string | null;
  countryside_id: number;
  country_l2_id: number | null;
  countrysides: LotListCountryside;
};

export type LotListCountryside = {
  id: number;
  name: string;
  active: boolean;
  created_at: Date | string;
  updated_at: Date | string | null;
  lat: string | null;
  lon: string | null;
  company_id: number;
  country_l2_id: number | null;
  companies: LotListCompany;
};

export type LotListCompany = {
  id: number;
  name: string;
  active: boolean;
  legal_name: string;
  tax_id: string;
  phone: string;
  email: string;
  organization_id: number;
  address_id: number | null;
  created_at: Date | string;
  updated_at: Date | string | null;
  organizations: LotListOrganization;
};

export type LotListOrganization = {
  id: number;
  name: string;
  active: boolean;
  legal_name: string;
  tax_id: string;
  phone: string;
  email: string;
  logo_url: string | null;
  poe_cycle: number | null;
  movement_notification_threshold: number;
  blockchain_enabled: boolean;
  prosegur_monitoring: boolean;
  agrotoken_integration: boolean;
  country_id: number;
  address_id: number | null;
  created_at: Date | string;
  updated_at: Date | string | null;
};

function toLotListResponse(data: LotListApiResponse): LotListResponse {
  const normalizedData = typeof data === 'string' ? JSON.parse(data) : data;

  return Array.isArray(normalizedData) ? (normalizedData as LotListResponse) : [];
}
